import styled from 'styled-components';

import ContentPlaceholder from '@/components/Base/ContentPlaceholder';
import {
  colorAccent250,
  colorWhite,
  mediaQueryDesktopMin,
  mediaQueryTabletSmallMin,
} from '@/styleUtils';

export const Block = styled.div`
  background-color: ${colorWhite};
  border-radius: 12px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;

  @media ${mediaQueryDesktopMin} {
    padding: 24px;
  }
`;

export const BackToCatalog = styled(ContentPlaceholder)`
  max-width: 190px;
  height: 16px;
`;

export const ProductTitle = styled(ContentPlaceholder)`
  max-width: 600px;
  height: 40px;
`;

export const CompanyInfo = styled(ContentPlaceholder)`
  max-width: 430px;
  height: 80px;
`;

export const ProductAdvantages = styled(ContentPlaceholder)`
  max-width: 500px;
  height: 24px;
`;

export const ProductDetails = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;
  flex-wrap: wrap;

  @media ${mediaQueryTabletSmallMin} {
    gap: 12px;
    flex-wrap: nowrap;
  }
`;

export const ProductDetail = styled(ContentPlaceholder)`
  display: flex;
  width: 100%;
  height: 80px;
  padding: 16px;
  border-radius: 12px;
  background-color: ${colorAccent250};

  &:not(:first-child) {
    width: calc(50% - 4px);

    @media ${mediaQueryTabletSmallMin} {
      width: 100%;
    }
  }
`;
